import {
  EMHandle,
  getEMsByLead,
  getEMSubordinatesByLead
} from "msd-capacity-planning-model";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useAllEMsSelector } from "./useAllEMs";


export const useEMByLeadRecusivelySelector = createSelector(
  [useAllEMsSelector],
  (ems) => {
    return getEMSubordinatesByLead(ems);
  }
);

export const useEMByLeadSelector = createSelector(
  [useAllEMsSelector],
  (ems) => {
    return getEMsByLead(Object.values(ems));
  }
);

export function useAllEMsByLead(recursive: boolean = false): {
  [lead: string]: EMHandle[];
} {
  const selector = recursive ? useEMByLeadRecusivelySelector : useEMByLeadSelector;
  return useSelector(selector);
}

export function useEMsByLead(
  year: number,
  month: number,
  recursive: boolean = false
): { [lead: string]: EMHandle[] } {
  const selector = recursive ? useEMByLeadRecusivelySelector : useEMByLeadSelector;
  const allByLead = useSelector(selector);
  const targetDate = new Date(year, month - 1); // months are 0-based

  const filtered: { [lead: string]: EMHandle[] } = {};

  for (const [lead, ems] of Object.entries(allByLead)) {
    const activeEms = ems.filter((em) => !em.isOffboarded(targetDate));
    if (activeEms.length > 0) {
      filtered[lead] = activeEms;
    }
  }

  return filtered;
}